import(/* webpackMode: "eager", webpackExports: ["ForgotPasswordForm"] */ "/vercel/path0/src/app/(auth)/forgot-password/components/ForgotPasswordForm.tsx");
